import { render, staticRenderFns } from "./ThreeDSecurePalla.vue?vue&type=template&id=6295f902&"
import script from "./ThreeDSecurePalla.vue?vue&type=script&lang=js&"
export * from "./ThreeDSecurePalla.vue?vue&type=script&lang=js&"
import style0 from "./ThreeDSecurePalla.vue?vue&type=style&index=0&id=6295f902&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports